/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".panel[_ngcontent-%COMP%]{color:#fff;display:flex;padding:8px;justify-content:space-between;align-items:center}.panel__count[_ngcontent-%COMP%]{flex:1 0 auto}.panel__clear[_ngcontent-%COMP%]{flex:0 0 auto;opacity:.3}"];
export { styles as styles };
